<template>
  <v-card>
    <v-toolbar
      :color="isCompleted ? 'grey' : type.color"
      dark
      flat
      dense
    >

      <v-toolbar-title>
        <v-icon>{{ type.icon }}</v-icon>
        {{ type.title }}
      </v-toolbar-title>
      <template v-if="isCompleted">
        <v-spacer />
        בוצעה ע״י {{ completedByString }} ב{{ completionDateString }}
      </template>
    </v-toolbar>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col
            cols="12"
            md="4"
            v-if="task.order"
          >
            <h3 class="body-2 grey--text">הזמנה מקושרת</h3>
            <span class="title black--text">{{ task.order }}</span>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <h3 class="body-2 grey--text">נוצרה בתאריך</h3>
            <span class="title black--text">{{ format(task.created, 'DD/MM/YYYY') }}</span>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <h3 class="body-2 grey--text">מועד לביצוע</h3>
            <span class="title black--text">{{ heDate(task.dueDate) }}</span>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { format } from "date-fns";
// import shouldShow from "@/utils/shouldShow";

export default {
  data() {
    return {
      removing: []
    };
  },
  computed: {
    completedByString() {
      let userId = this.task.completedBy;
      if (userId) {
        let user = this.$store.state.entities.users[userId];
        if (user) {
          return user.name;
        }
      }
      return "";
    },
    completionDateString() {
      let date = this.task.completionDate;
      if (date) {
        return this.heDate(date);
      }
      return "";
    }
  },
  props: ["task", "type", "isCompleted"],
  watch: {},
  mounted() {},
  methods: {
    format,
    heDate(d) {
      let date = new Date(d);
      let options = { weekday: "long", month: "long", day: "numeric" };
      return new Intl.DateTimeFormat("he-IL", options).format(date);
    }
  },
  components: {},
  mixins: []
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
